// SPDX-License-Identifier: AGPL-3.0-or-later

import {PREMIUM_PRODUCT_NAME} from '@app/features/app/config/I18nDisplayConstants';
import ShopCatalog from '@app/features/shop/state/ShopCatalog';
import {
	RECURRING_AVAILABLE_AFTER_DESCRIPTOR,
	RECURRING_ELIGIBILITY_DESCRIPTORS,
} from '@app/features/shop/utils/ShopMessageDescriptors';
import {getFormattedLongDate} from '@fluxer/date_utils/src/DateFormatting';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

// Micup: why renewing Plus, on sale here, is not offered to this account, and from when; nothing where it is offered
// or closed for everyone (sales off, no Paddle here).
export const ShopRecurringReason = observer(({className}: {className: string}) => {
	const {i18n} = useLingui();
	const eligibility = ShopCatalog.recurringEligibility;
	const reason = eligibility?.reason;
	if (
		!eligibility ||
		!ShopCatalog.recurringOffered ||
		!reason ||
		reason === 'sales_closed' ||
		reason === 'region_unavailable'
	)
		return null;
	return (
		<p className={className} role="status" data-flx="shop.shop-recurring-reason">
			{[
				i18n._(RECURRING_ELIGIBILITY_DESCRIPTORS[reason], {premiumProductName: PREMIUM_PRODUCT_NAME}),
				eligibility.available_after &&
					i18n._(RECURRING_AVAILABLE_AFTER_DESCRIPTOR, {
						date: getFormattedLongDate(new Date(eligibility.available_after), i18n.locale),
					}),
			]
				.filter(Boolean)
				.join(' ')}
		</p>
	);
});
